import { DOCUMENT } from '@angular/common';
import { Injector, afterNextRender } from '@angular/core';

/** Der Fokus liegt auf keinem Element mehr, etwa weil das fokussierte entfernt wurde. */
export function fokusVerloren(dokument: Document): boolean {
  const aktiv = dokument.activeElement;
  return !aktiv || aktiv === dokument.body;
}

/**
 * Liegt der Fokus jetzt in `bereich` und nach dem nächsten Rendern nicht mehr — weil die Aktion ihr eigenes
 * Element entfernt oder gesperrt hat —, bekommt ihn `ziel`. Sonst fiele er auf die Seite zurück, und die
 * Tastatur müsste von vorn beginnen.
 */
export function fokusImBereichHalten(bereich: HTMLElement, injector: Injector, ziel: () => void): void {
  const dokument = injector.get(DOCUMENT);
  if (!bereich.contains(dokument.activeElement)) return;
  afterNextRender(
    () => {
      if (!bereich.contains(dokument.activeElement)) ziel();
    },
    { injector },
  );
}
